import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=3cf20fa8&scoped=true"
import script from "./base-dialog.ts?vue&type=script&lang=ts&external"
export * from "./base-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=3cf20fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf20fa8",
  null
  
)

export default component.exports